<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Rendición de gasto</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Finanzas</span>
      <span> /</span>
      <span>Rendición de gasto</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-body align-items-center">
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="nroID"
            class="form-control"
            placeholder="Ej: RG-1003"
            required
            #nroID
          />
          <label for="nroID">Nro. ID</label>
        </div>
      </div>
      <div class="col" style="width: 50px;">
        <button
          mdbBtn
          type="button"
          class="btn-cuadrado"
          color="secondary"
          mdbWavesEffect
          (click)="seleccionarRendicionGasto.show()"
        >
          <mdb-icon fas icon="search"></mdb-icon>
        </button>
      </div>
    </div>

    <div class="row filtros-body">
      <div class="col dato">
        <Strong class="title">Usuario</Strong>
        <span class="value">Juan Pérez</span>
      </div>
      <div class="col dato">
        <Strong class="title">Fecha</Strong>
        <span class="value">dd/mm/aaaa</span>
      </div>
      <div class="col dato">
        <Strong class="title">Hora</Strong>
        <span class="value">hh:mm</span>
      </div>
      <div class="col dato">
        <Strong class="title">Estado</Strong>
        <span class="value"
          ><mdb-badge pill="true" default="true"
            >Pendiente de rendición</mdb-badge
          ></span
        >
      </div>
    </div>

    <div class="row filtros-body">
      <div class="col dato">
        <Strong class="title">Entregado a</Strong>
        <span class="value">Juan Pérez</span>
        <span class="value">9.999.999-9</span>
      </div>
      <div class="col dato">
        <Strong class="title">Recibido por</Strong>
        <span class="value">Juan Pérez</span>
        <span class="value">9.999.999-9</span>
      </div>
      <div class="col dato">
        <Strong class="title">Monto entregado</Strong>
        <span class="value">15.000</span>
      </div>
      <div class="col dato">
        <Strong class="title">Monto rendido</Strong>
        <span class="value">9.500</span>
      </div>
      <div class="col dato">
        <Strong class="title">Saldo por rendir</Strong>
        <span class="value">5.500</span>
      </div>
    </div>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Glosa</th>
            <th scope="col">RUT</th>
            <th scope="col">Nro. Dcto.</th>
            <th scope="col">Fecha</th>
            <th scope="col">Monto</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Pago proveedores</td>
            <td>9.999.999-9</td>
            <td>333999888</td>
            <td>24/06/2019</td>
            <td align="right">1.500</td>
          </tr>
          <tr>
            <td>Comprar ampolletas</td>
            <td>9.999.999-9</td>
            <td>333999888</td>
            <td>24/06/2019</td>
            <td align="right">1.500</td>
          </tr>
          <tr>
            <td>Bencina</td>
            <td>9.999.999-9</td>
            <td>333999888</td>
            <td>24/06/2019</td>
            <td align="right">1.500</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td align="right" colspan="4"><strong>Monto total</strong></td>
            <td align="right"><strong>120.000.500</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm">
      Agregar operación
    </button>
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm">
      Cerrar Rendición
    </button>
  </div>
</div>

<!-- MODAL seleccionarRendicionGasto -->
<div
  mdbModal
  #seleccionarRendicionGasto="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar rendición de gasto
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="seleccionarRendicionGasto.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col" style="max-width: 300px;">
            <div class="md-form">
              <input
                value=""
                type="text"
                id="nroRendicion"
                class="form-control"
                placeholder="Nro. Rendición"
                required
                #nroRendicion
              />
              <label for="nroRendicion">Nro. Rendición</label>
            </div>
          </div>
          <div class="col" style="max-width: 200px;">
            <div class="md-form">
              <mdb-date-picker
                [inline]="true"
                name="fechaRen"
                [placeholder]="'Fecha'"
                required
              ></mdb-date-picker>
            </div>
          </div>
        </div>

        <div
          class="row justify-content-between"
          style="border-top: 1px solid #dee2e6;"
        >
          <div></div>
          <button mdbBtn type="button" color="info" mdbWavesEffect>
            <mdb-icon fas icon="search"></mdb-icon>
            Buscar
          </button>
        </div>

        <table
          class="table table-striped table-hover table-sm align-middle mt-1"
        >
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Nro. Ren</th>
              <th scope="col">RUT</th>
              <th scope="col">Entregado a</th>
              <th scope="col">Monto</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1212</td>
              <td>12.999.999-2</td>
              <td>Juan Perez</td>
              <td align="right">100.000</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarRendicionGasto.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>1212</td>
              <td>12.999.999-2</td>
              <td>Juan Perez</td>
              <td align="right">100.000</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarRendicionGasto.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>1212</td>
              <td>12.999.999-2</td>
              <td>Juan Perez</td>
              <td align="right">100.000</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarRendicionGasto.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
